import React, { Component } from 'react';
import { Authenticator, Greetings } from 'aws-amplify-react';

class Login extends Component {
  render() {
    return <Authenticator hide={[Greetings]}/>;
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/modules/Login.js